/**
 * Alinhado ao enum RegistrationStatusEnum do backend (CustomerHeader.status).
 */
const REGISTRATION_STATUS_LABELS = {
    ACTIVE: 'Ativa',
    SUSPENDED: 'Suspensa',
    UNFIT: 'Inapta',
    CLOSED: 'Baixada',
    NULL: 'Nula',
};

const REGISTRATION_STATUS_DESCRIPTIONS = {
    ACTIVE:
        'A empresa está em dia com suas obrigações fiscais, tributárias e legais.',
    SUSPENDED:
        'Há inconsistências ou pendências cadastrais e fiscais, o que impede temporariamente a empresa de operar.',
    UNFIT: 'A empresa deixou de cumprir obrigações declaratórias por dois anos consecutivos.',
    CLOSED:
        'A empresa foi oficialmente encerrada, seja por decisão do empresário ou por decisão administrativa.',
    NULL: 'A inscrição é considerada inválida devido a fraude ou erro grave no cadastro.',
};

function normalizeStatusKey(status) {
    if (status == null || status === '') return null;
    return String(status).trim().toUpperCase();
}

export function getRegistrationStatusLabel(status) {
    const key = normalizeStatusKey(status);
    if (!key) return '—';
    return REGISTRATION_STATUS_LABELS[key] ?? String(status);
}

export function getRegistrationStatusDescription(status) {
    const key = normalizeStatusKey(status);
    if (!key) return '';
    return REGISTRATION_STATUS_DESCRIPTIONS[key] ?? '';
}

/** Opções para `<select>` (cadastro / filtros). */
export const REGISTRATION_STATUS_OPTIONS = Object.entries(REGISTRATION_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
}));
